import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './streamingServices.json';

const StreamingServices = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Streaming platforms, content creation, and media vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Streaming Services"
            image="/Images/streaming.webp"
            seoTitle="Free English Lesson Plans: Streaming Services"
            seoDescription="English exam exercises on streaming services. Practice grammar, vocabulary, reading, and speaking for B2/C1 level exams."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default StreamingServices;


